/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Modal_Warning_Notice2Inputs */

const en_coinvestments_canceldeal_modal_warning_notice2 = /** @type {(inputs: Coinvestments_Canceldeal_Modal_Warning_Notice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal will no longer be visible to organisations`)
};

/**
* | output |
* | --- |
* | "Deal will no longer be visible to organisations" |
*
* @param {Coinvestments_Canceldeal_Modal_Warning_Notice2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_modal_warning_notice2 = /** @type {((inputs?: Coinvestments_Canceldeal_Modal_Warning_Notice2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Modal_Warning_Notice2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_modal_warning_notice2(inputs)
});
export { coinvestments_canceldeal_modal_warning_notice2 as "coInvestments_cancelDeal_modal_warning_notice" }